import {
  faCheckCircle,
  faCircle,
  faXmarkCircle
} from '@fortawesome/free-regular-svg-icons';

const getDriverConfirmationStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Pending':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'Pending';
      break;
    case 'Approved':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Approved';
      break;
    case 'Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Rejected';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }

  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getPaymentStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Payment-Initiated':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'Pending';
      break;
    case 'Successful':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Paid';
      break;
    case 'Success':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Paid';
      break;
    case 'Setteled':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Paid';
      break;
    case 'Failed':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Failed';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }

  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getTripStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Started':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'Started';
      break;
    case 'Created':
      badgeColor = 'primary';
      badgeIcon = 'clock';
      badgeLabel = 'Created';
      break;
    case 'Ended':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Complete';
      break;
    case 'Breakdown':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Breakdown';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }

  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getVehicleStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Change':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'Approval pending';
      break;
    case 'Created':
      badgeColor = 'primary';
      badgeIcon = 'clock';
      badgeLabel = 'Created';
      break;
    case 'Active':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Active';
      break;
    case 'In-active':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'In-active';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }

  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getVehicleApprovalStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'New Truck':
      badgeColor = 'success';
      badgeIcon = 'plus-circle';
      badgeLabel = 'New Vehicle';
      break;
    case 'Change Driver':
      badgeColor = 'warning';
      badgeIcon = 'users';
      badgeLabel = 'Change Driver';
      break;
    case 'Assign Driver':
      badgeColor = 'primary';
      badgeIcon = 'user-plus';
      badgeLabel = 'Assign Driver';
      break;
    case 'Unassign Driver':
      badgeColor = 'secondary';
      badgeIcon = 'user-minus';
      badgeLabel = 'Unassign Driver';
      break;
    case 'Active':
      badgeColor = 'info';
      badgeIcon = 'truck';
      badgeLabel = 'Active Vehicle';
      break;
    case 'In-active':
      badgeColor = 'warning';
      badgeIcon = 'x';
      badgeLabel = 'In-active Vehicle';
      break;
    case 'Delete Truck':
      badgeColor = 'danger';
      badgeIcon = 'trash';
      badgeLabel = 'Delete Vehicle';
      break;
  }

  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getDriverApprovalStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'New Driver':
      badgeColor = 'success';
      badgeIcon = 'user-plus';
      badgeLabel = 'New Driver';
      break;
    case 'Edit Driver':
      badgeColor = 'primary';
      badgeIcon = 'users';
      badgeLabel = 'Edit Driver';
      break;
    case 'Active Driver':
      badgeColor = 'info';
      badgeIcon = 'user';
      badgeLabel = 'Active Driver';
      break;
    case 'Inactive Driver':
      badgeColor = 'warning';
      badgeIcon = 'x';
      badgeLabel = 'Inactive Driver';
      break;
    case 'Delete Driver':
      badgeColor = 'danger';
      badgeIcon = 'trash';
      badgeLabel = 'Delete Driver';
      break;
  }

  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getApprovalStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Approved':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Accepted';
      break;
    case 'Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Rejected';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      badgeLabel = 'status';
      break;
  }

  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};
const getApprovalStatusInventory = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'In Stock':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'In Stock';
      break;
    case 'Low Stock':
      badgeColor = 'warning';
      badgeIcon = 'x';
      badgeLabel = 'Low Stock';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      badgeLabel = 'status';
      break;
  }

  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getChallanType = status => {
  let badgeColor = '';
  let badgeLabel = '';
  switch (status) {
    case 'Other':
      badgeColor = 'warning';
      badgeLabel = 'Quick Pay';
      break;
    case 'Coal':
      badgeColor = 'primary-200';
      badgeLabel = 'Coal';
      break;
    case 'Iron Ore':
      badgeColor = 'success';
      badgeLabel = 'Iron Ore';
      break;
    case 'Fly Ash':
      badgeColor = 'primary';
      badgeLabel = 'Fly Ash';
      break;
    default:
      badgeColor = 'secondary';
      break;
  }

  return { color: badgeColor, label: badgeLabel };
};

const getSettlementStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Pending':
      badgeColor = 'warning';
      badgeIcon = 'alert-circle';
      badgeLabel = 'Pending';
      break;
    case 'First_Approved':
      badgeColor = 'success';
      badgeIcon = 'alert-circle';
      badgeLabel = 'Approved';
      break;
    case 'First_Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Reject';
      break;
    case 'Second_Approved':
      badgeColor = 'success';
      badgeIcon = 'alert-circle';
      badgeLabel = 'Approved';
      break;
    case 'Second_Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Reject';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};
const getApprovalSettlementStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'First_Approved':
      badgeColor = 'warning';
      badgeIcon = 'alert-circle';
      badgeLabel = 'Pending';
      break;
    case 'Second_Approved':
      badgeColor = 'success';
      badgeIcon = 'alert-circle';
      badgeLabel = 'Approved';
      break;
    case 'Second_Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Reject';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getSettlementModalStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Pending':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'On Checking';
      break;
    case 'First_Approved':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'On Approval';
      break;
    case 'Second_Approved':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'On Payment';
      break;
    case 'Third_Approved':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Paid';
      break;
    case 'First_Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Reject on Check';
      break;
    case 'Second_Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Reject on Approval';
      break;
    case 'Third_Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Failed Payment';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      badgeLabel = '';
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};
const getPaidSettlementStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Second_Approved':
      badgeColor = 'warning';
      badgeIcon = 'alert-circle';
      badgeLabel = 'Pending';
      break;
    case 'Third_Approved':
      badgeColor = 'success';
      badgeIcon = 'alert-circle';
      badgeLabel = 'Paid';
      break;
    case 'Third_Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Failed';
      break;
    case 'Payment_Initiated':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'Payment Initiated';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'incomplete':
      badgeColor = 'warning';
      badgeIcon = 'alert-circle';
      badgeLabel = 'Incomplete Detail';
      break;
    case 'Change':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'Approval Pending';
      break;
    case 'Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Approval Rejected';
      break;
    case 'Active':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Active';
      break;
    case 'In-active':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'In-active';
      break;
    case 'Pending':
      badgeColor = 'warning';
      badgeIcon = 'alert-circle';
      badgeLabel = 'Pending';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const truckerPaymentStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Pending':
      badgeColor = 'warning';
      badgeIcon = 'alert-circle';
      badgeLabel = 'Pending';
      break;
    case 'Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Rejected';
      break;
    case 'Active':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Active';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getPendingApprovalStatus = (status, name) => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = status;
  switch (status) {
    case `New ${name}`:
      badgeColor = 'success';
      badgeIcon = 'user-plus';
      break;
    case `Edit ${name}`:
      badgeColor = 'primary';
      badgeIcon = 'users';
      break;
    case `Active ${name}`:
      badgeColor = 'info';
      badgeIcon = 'user';
      break;
    case `Inactive ${name}`:
      badgeColor = 'warning';
      badgeIcon = 'x';
      break;
    case `Delete ${name}`:
      badgeColor = 'danger';
      badgeIcon = 'trash';
      break;
    case `Add ${name}`:
      badgeColor = 'success';
      badgeIcon = 'user-plus';
      break;
  }

  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};
const getAttendenceStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'On Leave':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'On Leave';
      break;
    case 'Present':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Present';
      break;
    case 'Absent':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Absent';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getLeaveStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Pending':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'Pending';
      break;
    case 'Approved':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Approve';
      break;
    case 'Declined':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Decline';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getPayrollHistoryStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Paid':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Paid';
      break;

    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};
const getPayrollHistoryTabStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Paid':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Paid';
      break;

    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getStatuseWayBill = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'not_allowed':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'Not-Allowed';
      break;
    case 'Allowed':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Allowed';
      break;

    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const vendorInvoices = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Paid':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Paid';
      break;

    case 'Rejected':
      badgeColor = 'danger';
      badgeIcon = 'x';
      badgeLabel = 'Rejected';
      break;

    case 'Pending':
      badgeColor = 'warning';
      badgeIcon = 'clock';
      badgeLabel = 'Pending';
      break;

    case 'Approved':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Approved';
      break;
    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getInvoiceDone = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Done':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Scanned';
      break;

    case 'Pending':
      badgeColor = 'warning';
      badgeIcon = 'x';
      badgeLabel = 'Not Scanned';
      break;

    case 'Scanned':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Scanned';
      break;

    case 'Not Scanned':
      badgeColor = 'warning';
      badgeIcon = 'x';
      badgeLabel = 'Not Scanned';
      break;

    case 'Edited':
      badgeColor = 'success';
      badgeIcon = 'check';
      badgeLabel = 'Edited';
      break;

    case 'Not Edited':
      badgeColor = 'warning';
      badgeIcon = 'x';
      badgeLabel = 'Not Edited';
      break;

    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const leaveStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Pending':
      badgeColor = 'warning';
      badgeIcon = faCircle;
      badgeLabel = 'Pending';
      break;

    case 'Declined':
      badgeColor = 'danger';
      badgeIcon = faXmarkCircle;
      badgeLabel = 'Declined';
      break;

    case 'Approved':
      badgeColor = 'success';
      badgeIcon = faCheckCircle;
      badgeLabel = 'Approved';
      break;

    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};
const challanCheckedStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case '1':
      badgeColor = 'success';
      badgeIcon = faCheckCircle;
      badgeLabel = 'Checked';
      break;

    case '2':
      badgeColor = 'danger';
      badgeIcon = faCircle;
      badgeLabel = 'Rejected';
      break;

    case '0':
      badgeColor = 'warning';
      badgeIcon = faCircle;
      badgeLabel = 'Pending';
      break;

    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const challanCheckApprovalStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Approved':
      badgeColor = 'success';
      badgeIcon = faCheckCircle;
      badgeLabel = 'Approved';
      break;

    case 'Rejected':
      badgeColor = 'danger';
      badgeIcon = faCircle;
      badgeLabel = 'Rejected';
      break;

    case 'Pending':
      badgeColor = 'warning';
      badgeIcon = faCircle;
      badgeLabel = 'Pending';
      break;

    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const challanApprovalStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Rejected':
      badgeColor = 'danger';
      badgeIcon = faCircle;
      badgeLabel = 'Rejected';
      break;

    case 'Checked Approved':
      badgeColor = 'warning';
      badgeIcon = faCircle;
      badgeLabel = 'Pending';
      break;

    case 'Approved':
      badgeColor = 'success';
      badgeIcon = faCheckCircle;
      badgeLabel = 'Approved';
      break;

    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

const getManuallPunchApprovalStatus = status => {
  let badgeColor = '';
  let badgeIcon = '';
  let badgeLabel = '';
  switch (status) {
    case 'Rejected':
      badgeColor = 'danger';
      badgeIcon = faCircle;
      badgeLabel = 'Rejected';
      break;

    case 'Approved':
      badgeColor = 'success';
      badgeIcon = faCheckCircle;
      badgeLabel = 'Approved';
      break;

    default:
      badgeColor = 'secondary';
      badgeIcon = 'x';
      break;
  }
  return { color: badgeColor, icon: badgeIcon, label: badgeLabel };
};

export {
  getSettlementModalStatus,
  getPaidSettlementStatus,
  getApprovalSettlementStatus,
  getManuallPunchApprovalStatus,
  challanCheckApprovalStatus,
  challanCheckedStatus,
  challanApprovalStatus,
  getAttendenceStatus,
  getDriverConfirmationStatus,
  getPaymentStatus,
  getTripStatus,
  getVehicleStatus,
  getVehicleApprovalStatus,
  getDriverApprovalStatus,
  getApprovalStatus,
  getChallanType,
  getStatus,
  getPendingApprovalStatus,
  getLeaveStatus,
  getPayrollHistoryStatus,
  getPayrollHistoryTabStatus,
  getStatuseWayBill,
  vendorInvoices,
  getInvoiceDone,
  leaveStatus,
  truckerPaymentStatus,
  getSettlementStatus,
  getApprovalStatusInventory
};
